
import Vuex from 'vuex'

const state = {
  detail:{},
  whiteList:['/install/detail','/service/detail'] 

};

const mutations = {
	
};

const getters = {
};

const actions = {
  
		

};

const store = () => new Vuex.Store({
	state,
	getters,
	mutations,
	actions
})

export default store;


// WEBPACK FOOTER //
// ./src/vuex/store.js